import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';
import { appendAttachment } from '../utils/FormDataUtils';

export const nonrefundableFundsService = {
  getAll,
  createOrUpdate,
  deleteSituation,
  search
};
const requestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  }
};
function search(searchFund, pageNumber) {
  let searchUrl = `${
    process.env.REACT_APP_API_URL
  }/api/annual_funds_programs/search?title=${searchFund.title}&archiveYear=${
    searchFund.archiveYear
  }&page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(searchUrl, requestOptions).then(
    responseHandleService.handleResponse
  );
}

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL
  }/api/annual_funds_programs/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions)
    .then(responseHandleService.handleResponse)
    .catch(error => console.log(error));
}
function createOrUpdate(newSituation) {
  const requestOptions = {
    method: newSituation.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newSituation)
  };

  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/annual_funds_programs${
    newSituation.id ? `/${newSituation.id}` : ''
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}
function createBodyRequest(situation) {
  let formData = new FormData();
  formData.append('annual_funds_program[add_date]', situation.date);
  formData.append('annual_funds_program[title]', situation.title);

  const document = situation.document;

  appendAttachment(formData, `annual_funds_program[document]`, document);

  return formData;
}
function deleteSituation(situationId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/annual_funds_programs/${situationId}`;

  return axios.delete(url, requestOptionsDelete);
}
